export const environment = {
  apiBaseUrl: '/api',
  businessKey: 'scent',
  appConfigFile: 'app-config.json'
};
